import React, {useEffect, useState} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import IntlTelInput from "react-intl-tel-input";

import {setAssignQuotePopupUserInfo, setAssignQuotePopupUserInfoErrors} from "./assignPopupFunctions";
import {useIsMounted} from "../../../../utilities/helperHooks";
import {getDefaultCountry, getPreferredCountries} from "../../../../utilities/twoFactorAuthView";
import {startsWith, trim} from "lodash";
import {getValidationErrors} from "../../../../utilities/validation";

const AssignQuotePopupNewCustomerPhoneInput = (props) => {

  const {property, userInfo, setAssignQuotePopupUserInfo, intl, placeholder, userInfoErrors, setAssignQuotePopupUserInfoErrors, inputsValidated,
    fabricatorData} = props;
  const isLowes = fabricatorData.isLowes;
  const [inputValue, setInputValue] = useState(userInfo[property]);
  const [country, setCountry] = useState(getDefaultCountry());
  const isMounted = useIsMounted();
  // const utilsScript = Config.getScriptPath() + "/libphonenumber.js";

  const handleInputBlur = () => {
    setAssignQuotePopupUserInfo({
      [property]: inputValue
    });
    const errors = getValidationErrors(inputValue, property);
    if (errors.length) {
      setAssignQuotePopupUserInfoErrors({
        [property]: errors
      })
    } else if (!errors.length && userInfoErrors[property]) {
      setAssignQuotePopupUserInfoErrors({
        [property]: errors
      })
    }
  };

  useEffect(() => {
    setInputValue(userInfo[property]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo[property]]);

  useEffect(() => {
    if (isMounted()) {
      console.log("inputsValidated", inputsValidated);
      handleInputBlur({
        target: {
          value: inputValue
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputsValidated]);

  // useEffect(() => {
  //   console.log('Do something after counter has changed', counter);
  // }, [counter]);

  const handleChangeNumber = (a, b, c, phoneNumber, forceCarrot = false) => {
    phoneNumber = phoneNumber.replace(/[^0-9\+\-\(\)\s]/gi, "");
    let prefix = `+${c.dialCode}`;
    if(country !== "auto" && country.dialCode) {
      prefix = `+${country.dialCode}`;
    }
    if (startsWith(phoneNumber, prefix + ' ') || trim(phoneNumber).length == 0) {
      let hasPrefix = phoneNumber.substring(0, prefix.length) == prefix;
      if (hasPrefix) phoneNumber = trim(phoneNumber.substring(prefix.length));
      phoneNumber = `${prefix} ${phoneNumber}`;
    }
    if (forceCarrot) {
      const forceCarrotFunc = () => {
        let p = document.getElementById('phone');
        p.selectionStart = phoneNumber.length;
        p.selectionEnd = phoneNumber.length;
      }
      window.setTimeout(forceCarrotFunc, 10);
    }
    setInputValue(phoneNumber);
    if (userInfoErrors[property]) {
      const errors = getValidationErrors(phoneNumber, property);
      if (!errors.length) {
        setAssignQuotePopupUserInfoErrors({
          [property]: errors
        })
      }
    }
  };

  const handleChangeFlag = (currentNumber, selectedCountryData) => {
    const matches = currentNumber.match(/(\+\d{1,4}\s)/gi);
    currentNumber = currentNumber.replace(/\+\d{1,4}\s/gi, '');

    const numberSplitted = currentNumber.split("+"+selectedCountryData.dialCode);
    const number = numberSplitted[numberSplitted.length - 1] || "";

    currentNumber = (matches && matches.length > 1)
      ? `${matches[1]}${currentNumber}`
      : `+${selectedCountryData.dialCode} ${number}`;

    setCountry(selectedCountryData);
    setAssignQuotePopupUserInfo({phoneNumber: currentNumber});
  };

  const errorsExist = Array.isArray(userInfoErrors[property]) && userInfoErrors[property].length;

  return (
    <div className="ass-field">
      <IntlTelInput inputClassName={"ui-input ui-input--new ass-field__input" + (errorsExist ? " ui-input--error" : "")}
                    containerClassName={isLowes ? "intl-tel__lowes" : "intl-tel-input"}
                    // utilsScript={utilsScript}
                    value={inputValue}
                    onSelectFlag={handleChangeFlag}
                    preferredCountries={getPreferredCountries()}
                    placeholder={intl.formatMessage({id: placeholder})}
                    onlyCountries={isLowes ? ["ca"] : []}
                    excludeCountries={isLowes ? ["us"] : []}
                    allowDropdown={!isLowes}
                    onPhoneNumberChange={handleChangeNumber}
                    defaultCountry={country.iso2 || country}
                    onPhoneNumberBlur={handleInputBlur}
                    maxLength={16}
                    fieldId="phone"
      />
      {errorsExist ? (
        <div className="ass-field__errors">
          {userInfoErrors[property].map((error, errorIndex) => {
            return (
              <span className="ass-field__errors-error" key={errorIndex}>
                <FormattedMessage id={error}/>
              </span>
            )
          })}
        </div>
      ) : null}
    </div>
  )
};

AssignQuotePopupNewCustomerPhoneInput.propTypes = {
  property: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  inputsValidated: PropTypes.bool.isRequired,
};

const mapStateToProps = (store) => {
  const {userInfo, userInfoErrors} = store.assignQuoteState;
  return {
    userInfo,
    userInfoErrors,
    fabricatorData: {}
    // assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText
  };
};

const mapDispatchToProps = {
  setAssignQuotePopupUserInfo,
  setAssignQuotePopupUserInfoErrors
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupNewCustomerPhoneInput)
)
